import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, ViewChild, TemplateRef} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Location} from '@angular/common';
// Notifications
// import { HotToastService } from '@ngneat/hot-toast';
import { DatePipe } from '@angular/common';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { Observable } from 'rxjs'; // this created errors ats use below
// import {Observable} from 'rxjs/Rx';

// import {Observable} from 'rxjs';
// import { ajax } from 'rxjs/observable/dom/ajax';


// import { FileUploadsModalComponent } from './../../../manager/file-uploads-modal/file-uploads-modal.component';
// import {UploadDocxTemplateModalComponent} from './../upload-docx-template-modal/upload-docx-template-modal.component';
// import {UploadEmailTemplateModalComponent} from './../upload-email-template-modal/upload-email-template-modal.component';

import { MysqlService } from './../../../services/mysql.service';
import { Brand } from '../../../shared/models/brand.model';
import {SubjectTemplateDocs} from '../../../shared/models/subjectTemplateDocsModel.model';
import {SubjectComTypes} from '../../../shared/models/subjectComTypesModel.model';

import { FormsModule, Validators } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UploadDocxThemeTemplateComponent } from '../upload-docx-theme-template/upload-docx-theme-template.component';
import { GlobalFunctionsService } from './../../../services/global-functions.service';

@Component({
  selector: 'app-subject-com-type-edit',
  templateUrl: './subject-com-type-edit.component.html',
  styleUrls: ['./subject-com-type-edit.component.css']
})
export class SubjectComTypeEditComponent implements OnInit {

  nav: any;
  doc_id: number;
  model: SubjectComTypes;
  subject_template_doc: Object;


  public baseUploadURL:any;
  @ViewChild('brandForm') form: any; // the name of the form to access.
  bsModalRef: BsModalRef;
  // MODAL
  modalRef: BsModalRef;
  stripped: any;
  filenameselected: any;
  brand_types: any;
  baseUploadURLEmailTemplates: string;
  subject_com_types: any;
  sent_subject_com_type_id: any;
  subject_com_type_id: number;
  subject_com_type: any;
  baseUploadURLOriginalWordTemplates: string;
  baseUploadURLDocxThemeTemplates: string;

  constructor(
    private _mysqlService: MysqlService,
    private route: ActivatedRoute,
      private router: Router,
      private http: HttpClient,
      private _demoService: DemoService,

      vcr: ViewContainerRef,
      private modalService: BsModalService,
      private _location: Location,
      public gfunc: GlobalFunctionsService
  ) {

    this.baseUploadURL = this.gfunc.baseUploadURL; // all templates reside in the same directory.
    this.baseUploadURLOriginalWordTemplates = this.gfunc.baseUploadURLOriginalWordTemplates;
    this.baseUploadURLEmailTemplates = this.gfunc.baseUploadURLEmailTemplates; // all templates reside in the same directory.
    this.baseUploadURLDocxThemeTemplates = this.gfunc.baseUploadURLDocxThemeTemplates;

    this.nav = document.querySelector('nav.navbar');
    // this.toastr.setRootViewContainerRef(vcr);
    this.subject_com_type_id = +this.route.snapshot.paramMap.get('subject_com_type_id');
    
   }

  ngOnInit() {

    this.model = new SubjectComTypes();
    this.getSubjectComType(this.subject_com_type_id);
    this.getBrandTypes();
    this.getSubjectComTypes();
  }


  getSubjectComType(subject_com_type_id) {
    this._demoService.getSubjectComType(subject_com_type_id).subscribe(
      data => { this.subject_com_type = data; },
      err => console.error(err),
      () => console.log('')
    );
  }

// need to change this below
editComType(model){
  // model.job_id = this.job_id;
   this._demoService.updateSubjectComType(model).subscribe(

    data => { // this.trace_candidate_update = data;
      // refresh the list
     // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
    // this.toastr.success('Communication Type Updated');
  //  this.createJobSubjectsMultiple(model);
    // Subject to reload the manager component parent.
   // TraceCandidateManagerComponent.returned.next(false);
  // this.router.navigate(['/admin/jobs/create-job-3/' + model.job_id + '']);
  // this.router.navigate(['/admin/jobs/view/' + model.job_id + '']);

              return true;
    },
    // error => {
    //  // console.error('Error saving Event!');
    //   this.toastr.error('Error saving Document!');
    //   return Observable.throw(error);
    // },
    err => console.error(err),
    () => console.log('done updates')
);
  }



 getBrandTypes() {
  this._demoService.getBrandBrandTypes().subscribe(
     data => { this.brand_types = data; },
     err => console.error(err),
     // () => console.log('done loading candidate for update')
   );
 }

    private getSubjectComTypes() {
      this._demoService.getSubjectComTypes()
        .subscribe(
          res => this.subject_com_types = res,
          err => console.error(err.status)
        );
    }

    sendSubjectComTypeID(subject_com_type_id) {
      // do nothing
        }



     // to router navigate back
     public goBack() {
      this._location.back();
    }

    docView(doc_id) {
      this.router.navigate(['/admin/communication/com_type_template_doc_view/' + doc_id + '']);
    }

    docEdit(doc_id) {
      this.router.navigate(['/admin/communication/com_type_template_doc_edit/' + doc_id + '']);
    }




      // MODAL view a component
      openModalUploadDocxThemeTemplate() {
        const initialState = {
          title: 'Upload Docx Theme Document',
          item_id: 1010,
          doc_id: this.doc_id,
          size: 'lg',
          backdrop: true,
          IgnoreBackdropClick: false,
        };
        this.bsModalRef = this.modalService.show(UploadDocxThemeTemplateComponent, {initialState});
        // sets the var to in the component model
        this.bsModalRef.content.doc_id = this.doc_id;
        this.bsModalRef.content.item_id = this.doc_id;
        this.bsModalRef.content.title = 'Original Word Files';
        this.bsModalRef.content.closeBtnName = 'Close';
       // this.bsModalRef.content.brand_model = this.subject_template_doc;
        // subscribed to the emitter and get the value.
              //     this.bsModalRef.content.action.take(1).subscribe((value) => {
              //   // console.log(value); // here you will get the value of the file
              //   // Remove the "uploads/" part from the filename.
              //   this.filenameselected = value;
              //  // this.stripped = this.filenameselected.replace('uploads/', '');
              //   // this.model.main_image = this.stripped; // works for simple add not update.
              //   // console.log(this.stripped);
              //   // console.log(this.model);
              //   // this.form.logo = this.stripped;
              //  // this.form.doc_template_file = this.filenameselected;
              //   this.form.document_base_theme_docx = this.filenameselected;
              //   // this.form.reset();
              //   // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
              //   this.form.controls['document_base_theme_docx'].patchValue(this.form.document_base_theme_docx);

              //   });
              this.bsModalRef.content.action.subscribe(this.addFileNameFromModal_TD.bind(this)); /// Angular 14 working.....
       }


		// :: Parent / Child modal test
		public addFileNameFromModal_TD(filename) {
		  alert('Clicked');
		  this.form.controls['document_base_theme_docx'].patchValue(filename); // works by setting the new frorm value from parent modal.
      // has to be correct form name
		// this.modalRef.hide();
		// console.log('Added External Recipeint.');
		// this.toastr.info('External Recipient Added');
		};


}
